module.exports = __webpack_public_path__ + "media/images/riders/JURE_ZABJEK-62da607e4328dbbf1e534ae660ca0c4a.png";